export const setCarInquiryDetails = details => ({
    type: "SET_CAR_INQUIRY_DETAILS",
    payload: details
});

export const selectCar = car => ({
    type: "SELECT_CAR",
    payload: car
});